module.exports = __webpack_public_path__ + "static/media/address--input-background.29532f36.svg";